// English translations
const EnTranslations = {
    translation: {
      welcome: 'Welcome',
      about: 'About',
      contact: 'Contact',
    },
    header:{
        blogs: 'Blogs',
        cta: 'Book now',
    },
    mainText: {
        slogan: 'We build websites',
        tailored: 'tailored',
        slogan1: 'for your business',
        slogan2: 'Making your vision, our',
        workOfArt: 'work of art',
        headline1: 'We Put Your Business',
        headline2: 'On the Web',
        subheading: 'and Ahead of the Competition',
        landingParagraph: 'From strategy and design to development and CMS integration, we build websites that work as hard as you do. Tailored for medium to large enterprises, with the flexibility your marketing team needs to thrive.',
        offeringTitle: 'Custom websites that turn visitors into customers.',
        offeringText: 'We specialize in web design, development, and user experience optimization. From business sites to complex web apps, we deliver tailored digital solutions that align with your goals and drive results',
        offeringText2: 'Offering your business a full ready to roll solution.',
        portfolio: 'Discover Our Masterpieces',
        commingSoon: 'Coming soon ...',
        struggle: 'Struggling to display your most significant work to the world?',
        struggle2: 'Click anywhere to shine the spotlight',
        struggle3: 'Shine a spotlight on your achievements',
        struggle4: 'bring your best work to life and share them with the world',
        yourProject: 'Transform Your Vision into Reality!',
        yourProjectText: 'Unlock the potential of your business with our comprehensive, turnkey solution!',
        yourProjectSub: 'Your Project, Here!',
    },
    serviceText: {
        title: 'Elevate your performance with our insightful services',
        webDevelopment: 'Web Development',
        webDevelopmentText: 'We design and develop websites that are beautiful, functional, and optimized to turn your visitors into customers',
        webDesign: 'Web Design',
        webDesignText: 'We create captivating, contemporary websites that blend beauty, functionality, and user-friendliness tailored to reflect your brand',
        webHosting: 'Web Hosting',
        webHostingText: 'We provide a secure, reliable, and affordable hosting service for your website. We also offer domain registration and management',
        webMaintenance: 'Web Maintenance',
        webMaintenanceText: 'We offer a website maintenance service to ensure your website is up to date and secure. We also offer a website redesign service',
        unlimitedSupport: 'Unlimited Support',
        unlimitedSupportText: ' We are always available to help you with any questions you may have. We are here to help you grow your business',
        montlyPlan: 'Monthly Plan',
        montlyPlanText: 'We offer different monthly plans to help you get started with your website. We also offer a custom plan to suit your needs',

    },


    buttonText: {
        scheduling: 'Let\'s Get Started!',
        ourRecentWork: 'Our Recent Work',
    },

    formText: {
        schedulingAppointment: 'Engage with Our Expertise',
        schedulingSlogan:'We will contact you in less than a flash',
        fullname: 'Full Name',
        email: 'Email',
        phone: 'Phone number',
        submit: 'Submit',
        submitting: 'Submitting...',
        thankYou: 'Thank you',
        responseMessage: "We've received your message and will be in touch shortly!",
    },

    aboutUs: {
        title: 'The professional behind the magic',
        subtitle: 'We are passionate professionals dedicated to helping businesses grow and succeed. We provide full service web design and development. We build websites, web applications, and web experiences. 100% satisfaction guaranteed.',
        vision: "Empowering Digital Dreams",
        visionText: "At ontheweb, we believe every business can unlock its digital potential. We're not just crafting websites; we're building gateways to your success. Our passion fuels us to push the boundaries of web design and development, transforming entrepreneurial dreams into captivating digital realities. We're committed to excellence and your 100% satisfaction. Let's shape the future of online business together. Your success is our vision—let's make it happen!",
        matanSubtitle: 'Lead Developer / Designer',
        matanText: 'Hey there! I\'m Matan, a dedicated full-stack developer. Skilled in crafting robust solutions, I thrive on helping businesses succeed with clean, efficient code. Let\'s build something amazing together!',
        matanExtraText:'founder',
        
        clickHere: 'Check out our toolbox',
    },
    blog: {
        share: {
            text: 'Like what you\'ve read? Share with a special someone! ',
            button: 'Share',
            defaultTitle: 'Interesting blog post',
            defaultDescription: 'Check out this interesting blog post!',
            copySuccess: 'Link copied to clipboard!'
        },
        textToSpeech: {
            start: 'Listen',
            stop: 'Stop',
            error: 'There was an error with the text-to-speech service. Please try again.',
            notSupported: 'Text-to-speech is not supported by your browser.'
        }
    },
    toolbox:{
        title: 'Toolbox',
        description: 'A collection of useful tools for designers and developers',
        visit: 'Visit Website',
        categories: {
            all: 'All Tools',
            fonts: 'Fonts',
            designResources: 'Design Resources',
            designInspiration: 'Inspiration',
            colors: 'Color Tools',
            dev: 'Dev Tools',
            gamesTools: 'Games',
            generatorsTools: 'Generators',
            webUtils: 'Web Utilities',
            ai: 'AI Tools'
        },
        filters: {
            title: 'Filter Tools',
            show: 'Show Filters',
            hide: 'Hide Filters'
        },
        views: {
            marquee: 'Marquee View',
            list: 'Details View',
            toggle: 'Toggle View'
        },
        search: {
            placeholder: 'Search for tools...',
            noResults: 'No tools found matching your search',
            clear: 'Clear search'
        },
        suggestToolPrompt: 'Can\'t find what you\'re looking for? Let us know!',
        suggestToolButton: 'Suggest a tool',
        ai: {
            assistantButton: 'AI Recommendations',
            modalTitle: 'AI Tool Finder',
            description: 'Describe what you\'re looking for and let our AI find the perfect tools for you. Just type naturally, like you\'re talking to a friend.',
            inputPlaceholder: 'What are you looking for?',
            searchButton: 'Search',
            loadingText: 'Finding the best tools for you...',
            loadingMessages: [
                'Searching through {{count}} tools...',
                'Analyzing your request...',
                'Almost there, finding the best matches...',
                'Finalizing recommendations...',
                'Digging through the toolbox...',
                'Matching your needs with the perfect tools...',
                'Our AI is on the hunt...',
                'Scanning the collection...',
                'Finding hidden gems for you...',
                'Curating your personalized list...'
            ],
            resultsTitle: 'Recommended Tools',
            noResults: 'No matching tools found. Try different keywords.',
            closeButton: 'Close'
        },
        suggestTool: {
            title: 'Suggest a Tool',
            subtitle: 'Help us grow our toolbox collection!',
            placeholders: {
                toolName: 'Tool name',
                toolUrl: 'Tool URL',
                category: 'Tool category',
                description: 'Short description (max 300 characters)',
                name: 'Name (optional)',
                email: 'Email'
            },
            buttons: {
                generate: 'Generate description',
                generating: 'Generating...',
                submit: 'Submit suggestion',
                submitting: 'Submitting...'
            },
            validation: {
                toolNameRequired: 'Tool name must be at least 2 characters',
                urlInvalid: 'Please enter a valid URL starting with http:// or https://',
                categoryRequired: 'Please select a category',
                descriptionRequired: 'Description is required',
                descriptionTooLong: 'Description must be 300 characters or less',
                emailInvalid: 'Please enter a valid email address'
            },
            success: {
                generated: 'Description generated successfully!',
                submitted: 'Thanks! Your suggestion was sent.'
            },
            errors: {
                generateFailed: 'Could not generate description. Try again or write your own.',
                submitFailed: 'Send failed. Please try again.'
            },
            labels: {
                toolName: 'Tool Name',
                description: 'Description',
                category: 'Category'
            },
            loading: {
                extractingInfo: 'Extracting tool info...'
            },
            placeholderText: {
                toolName: 'Click to add tool name',
                description: 'Click to add description'
            }
        }
    },

    blogs: {
        title: 'Blogs',
        recentPosts: 'Recent Posts',
        loadMore: 'Load More',
        comingSoon: 'Stay tuned for our latest blogs',
    },

    cta:{
        title: 'Ready to elevate your business with ontheweb?',
        text: 'Let\'s make your vision a reality!',
    },

    footerQuote: {
        text: 'ontheweb | Putting Your Business On the Web',
    },

    errorLoadingContent: 'Oops! The blog you are looking for is not available.',
    postNotFound: 'But that\'s okay! Check out one of our other blogs',
    projects: {
        viewProject: 'View Project'
    },
};

export default EnTranslations;
